import { PureComponent, Fragment, createRef } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import NavigationPrompt from 'react-router-navigation-prompt';

import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
  AvInput,
} from 'availity-reactstrap-validation';

import AvRadio from 'availity-reactstrap-validation/lib/AvRadio';
import AvRadioGroup from 'availity-reactstrap-validation/lib/AvRadioGroup';

import {
  Button,
  Confirm,
  Dropdown,
  Grid,
  Icon,
  Loader,
  Modal,
  Segment,
} from 'semantic-ui-react';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
  Heading,
} from 'ckeditor5';

import { CKEditor } from '@ckeditor/ckeditor5-react';

import addCustom from '../../../../assets/add-icon-white-bg.svg';

import {
  CustomAccordion,
  CustomSegment,
  CustomTable,
  ShowEvaluationQuestion,
  CustomTooltip,
} from '../../../../components';

import {
  cloneDeep,
  compact,
  filter,
  find,
  get,
  isEmpty,
  isEqual,
  map,
  pick,
  size,
  sum,
  unionBy,
  uniq,
  sortBy,
  omit,
  orderBy,
} from '../../../../utils/lodash';

import {
  clearMethodQuestions,
  deleteEvaluationPlan,
  getEvaluationGroups,
  getMethodQuestions,
  postEvaluationPlan,
  updateEvaluationPlan,
  updateSeriesSubtitle,
  deleteSeriesSubtitle,
  getEvaluationPlans,
} from '../../../../store/actions';

import {
  getPageDisable,
  getPreviewSurveyLink,
  stopPropagation,
} from '../../../../utils';
import { INSTANCE_WITH_CULTURE_COUNTS } from '../../../../utils/instanceConstant';

import {
  formatEvaluationPlanDisplayName,
  getEvaluationPlanBaseName,
  getNextEvaluationPlanName,
} from '../../../../utils/evaluationPlan';

import { UserTextService } from '../../../../services';
import { SeeMore } from '../../../../components/customToggle';

import './index.scss';
import '../activity.scss';

// TAK-2067: the recommended sample size is hidden until it is moved and
// refactored. Its participant count uses actual group sizes, which are 0
// before an activity runs, so it always recommended 0. Set to true to show it
// again in the evaluation plan form and preview.
const SHOW_RECOMMENDED_SAMPLE_SIZE = false;

// TODO:mgr-assessed -> we should move internal db fields to "Manager-assessed' to
// get rid of this kind of bollocks
const formatEvaluationResponseLabel = (methodology, t) =>
  methodology.response_id === 'Self-assessed'
    ? t('survey.mgr_assessed')
    : methodology.response;

class CustomSuccessMessage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      text: get(props.form, 'successMessage', ''),
    };
  }

  getCustomSuccessMessage() {
    return this.state.text;
  }

  render() {
    const { text } = this.state;
    const { helpTips, user, t } = this.props;

    return (
      <Grid.Row className="evalPlan-question">
        <CustomTooltip
          state={get(user, 'options.tips')}
          contentObject={{
            data: helpTips,
            key: '215',
          }}
          position="top left"
          wide="very"
        >
          <div className="question-text">
            {t('activity.evaluation.survey_completion_message')}
          </div>
        </CustomTooltip>
        <div className="outputs-col-div">
          <div>
            <CKEditor
              editor={ClassicEditor}
              className="custom-question-input"
              config={{
                plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
                toolbar: [
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  'bulletedList',
                  'numberedList',
                ],
              }}
              data={text}
              onChange={(event, editor) => {
                const text = editor.getData();
                this.setState({
                  text,
                });
              }}
            />
          </div>
        </div>
      </Grid.Row>
    );
  }
}

const getEvaluationParticipantCount = (participantGroup, evalPlan = {}) => {
  const participantCount = get(participantGroup, 'participantCount', null);

  if (
    get(evalPlan, 'seriesParticipantCountVaries', false) &&
    participantCount !== null &&
    participantCount !== undefined
  ) {
    return Number(participantCount);
  }

  return Number(
    get(
      participantGroup,
      'targetGroup.actualSize',
      get(participantGroup, 'actualSize', get(participantGroup, 'size', 0))
    )
  );
};

class EvaluationPlanRespondent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isBetaQuestionText: props.form.isBetaQuestionText,
      isBetaQuestionTextTemp: false,
      selectedMethod: null,
      selectedResponse: null,
      selectedCollectionMethod: null,
      selectedCollectionButton: false,
      confirmDocInfo: false,
      confirmQuestionTextChange: false,
      isSeries: false,
      seriesCount: null,
      modal: false,
      checkBoxDisabled: false,
      popupShown: false,
      isTakker: false,
    };
  }

  componentDidMount() {
    const { form } = this.props;
    this.setState({
      isBetaQuestionText: form?.isBetaQuestionText || false,
      selectedMethod: form?.method_id || null,
      selectedResponse: form?.response_id || null,
      selectedCollectionMethod: form?.collectionMethod || null,
      isTakker: form?.isTakker || false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.selectedCollectionMethod !== null &&
        prevState.selectedCollectionMethod !==
          this.state.selectedCollectionMethod) ||
      prevProps.selectedObjective !== this.props.selectedObjective
    ) {
      this.methodQuestions();
    }

    if (prevState.selectedResponse !== this.state.selectedResponse) {
      this.props.getSelfAssessedResponse(this.state.selectedResponse);
    }

    if (
      prevState.selectedCollectionButton !== this.state.selectedCollectionButton
    ) {
      this.props.getCollectionMethodForButton(
        this.state.selectedCollectionButton
      );
    }
  }

  getIsBetaQuestionText() {
    return this.state.isBetaQuestionText;
  }

  getIsTakker() {
    return this.state.isTakker;
  }

  getSelectedMethod() {
    return this.state.selectedMethod;
  }

  getSelectedCollectionMethod() {
    return this.state.selectedCollectionMethod;
  }

  getSelectedResponse() {
    return this.state.selectedResponse;
  }

  getCustomQuestions() {
    return this.customQuestions?.getQuestions() || [];
  }

  getEvaluationQuestion() {
    const { form, surveyQuestions } = this.props;
    let getQuestions = {
      questions: [],
      facilitatorNote: '',
    };

    if (!isEmpty(surveyQuestions)) {
      getQuestions = surveyQuestions;
    } else {
      if (!isEmpty(form.evaluationQuestions)) {
        getQuestions = {
          questions: form.evaluationQuestions,
          facilitatorNote: form.facilitatorNote,
        };
      }
    }

    return map(getQuestions.questions, (question, i) =>
      this[`showQuestions${i}`].getEvaluationQuestion()
    );
  }

  getCustomSuccessMessage() {
    return this.customMessage?.getCustomSuccessMessage() || '';
  }

  methodQuestions = async () => {
    const {
      t,
      getMethodQuestions,
      evaluationMethod,
      currentActivity,
      selectedObjective,
    } = this.props;

    try {
      const { selectedResponse, selectedMethod } = this.state;
      if (!selectedResponse || !selectedMethod) {
        return;
      }

      const method = find(evaluationMethod, {
        response_id: selectedResponse,
        method_id: selectedMethod,
      });

      const outcomes = compact(
        map(currentActivity.objective, (objective) => {
          if (selectedObjective.includes(objective.id)) {
            return objective.outcomeId;
          }
        })
      );

      const isBetaQuestionText = this.getIsBetaQuestionText();

      await getMethodQuestions(
        method.id,
        outcomes,
        currentActivity.organisationId,
        isBetaQuestionText
      );
    } catch (error) {
      NotificationManager.error(t('common.something_went_wrong'));
    }
  };

  handleQuestionStyleChange = async () => {
    // we need to tell each ShowQuestion component that the questions
    // are about to change due to a toggle on question style
    // (they need to stash current text so any placeholders can be
    // brought across when the new questions are loaded)
    const questions = this.getPlanQuestionsTrimmedAndSortedByObjective();
    for (const idx in questions) {
      this[`showQuestions${idx}`].prepareForQuestionStyleChange();
    }

    await this.methodQuestions();
  };

  handleChangeResponse = (selectedResponse) => {
    const { selectedMethod, selectedCollectionMethod } = this.state;
    if (selectedResponse !== 'Participant') {
      this.setState(
        {
          selectedMethod:
            selectedMethod === 'Intercept' ? null : selectedMethod,
          selectedResponse,
          selectedCollectionMethod:
            selectedCollectionMethod === 'CULTURECOUNTS'
              ? 'LINK'
              : selectedCollectionMethod,
          selectedCollectionButton:
            selectedResponse === 'Self-assessed'
              ? null
              : Boolean(selectedMethod),
        },
        () => {
          if (selectedResponse !== 'Self-assessed') {
            this.methodQuestions();
          }
        }
      );
    } else {
      this.setState(
        {
          selectedMethod,
          selectedResponse,
          selectedCollectionMethod: selectedCollectionMethod || 'LINK',
          selectedCollectionButton:
            selectedResponse === 'Self-assessed'
              ? null
              : Boolean(selectedMethod),
        },
        () => {
          if (selectedResponse !== 'Self-assessed') {
            this.methodQuestions();
          }
        }
      );
    }
  };

  handleChangeMethod = (selectedMethod) => {
    const { selectedCollectionMethod } = this.state;
    this.setState(
      {
        selectedMethod,
        selectedCollectionMethod: selectedCollectionMethod || 'LINK',
        selectedCollectionButton: true,
      },
      () => {
        this.methodQuestions();
      }
    );
  };

  handleCollectionMethod = (selectedCollectionMethod) => {
    this.setState({
      selectedCollectionMethod,
      selectedCollectionButton: true,
    });
  };

  handleEvaluationSeries(status) {
    this.props.handleEvaluationSeries(status);
  }

  renderBasedCollectionMethod(selectedCollectionMethod) {
    const { t } = this.props;

    switch (selectedCollectionMethod) {
      case 'CULTURECOUNTS':
        // TAK-2088: no "Go to Culture Counts" link once the instance no
        // longer offers it
        if (!INSTANCE_WITH_CULTURE_COUNTS) {
          return null;
        }
        return (
          <div className="culture-count-container">
            <a
              href={'https://culturecounts.cc/sign-in'}
              rel="noopener noreferrer"
              target="_blank"
              className="culture-count-a"
            >
              <div className="culture-count">
                <span>
                  {t('activity.evaluation.go_to_culture_counts')}
                  <Icon name="external alternate" className="ml-3 mb-1" />
                </span>
              </div>
            </a>
          </div>
        );
      case 'LINK':
      case 'CSV':
        return (
          <Fragment>
            <CustomQuestion
              ref={(c) => (this.customQuestions = c)}
              {...this.props}
            />
            <div className="sep-line-eval" />

            <CustomSuccessMessage
              ref={(c) => (this.customMessage = c)}
              {...this.props}
            />
          </Fragment>
        );
      default:
        return null;
    }
  }

  getMethodKey(response) {
    let key = '';
    switch (response) {
      case 'Interview':
        key = '147';
        break;
      case 'Questionnaire':
        key = '148';
        break;
      case 'Focus Group':
        key = '149';
        break;
      case 'Intercept':
        key = '216';
        break;
      default:
        break;
    }

    return key;
  }

  getResponsesKey(response) {
    let key = '';
    switch (response) {
      case 'Participant':
        key = '143';
        break;
      case 'Proxy':
        key = '144';
        break;
      case 'Expert':
        key = '145';
        break;
      case 'Self-assessed':
        key = '146';
        break;
      default:
        break;
    }

    return key;
  }

  getPlanQuestions() {
    const { surveyQuestions, form } = this.props;

    let qsts = {
      questions: [],
      facilitatorNote: '',
    };

    if (!isEmpty(surveyQuestions)) {
      qsts = surveyQuestions;
    } else if (!isEmpty(form.evaluationQuestions)) {
      qsts = {
        questions: form.evaluationQuestions,
        facilitatorNote: form.facilitatorNote,
      };
    }

    return qsts;
  }

  getPlanQuestionsTrimmedAndSortedByObjective(fullQuestionInfo = null) {
    if (!fullQuestionInfo) {
      fullQuestionInfo = this.getPlanQuestions();
    }

    const { selectedObjective } = this.props;
    const sortedObjectives = sortBy(selectedObjective);
    let questions = sortBy(fullQuestionInfo.questions, (i) => i.objectiveId);
    questions = map(questions, (q, i) => {
      if (!q.objectiveId) {
        q.objectiveId = sortedObjectives[i];
      }
      return q;
    });

    return questions;
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  showQuestions() {
    const { selectedResponse, selectedMethod } = this.state;
    const qsts = this.getPlanQuestions();
    return !isEmpty(qsts) && selectedResponse && selectedMethod;
  }

  toggleBetaQuestionText = (value) => {
    const { editMode } = this.props;

    if (editMode && this.showQuestions()) {
      this.setState({
        isBetaQuestionTextTemp: value,
        confirmQuestionTextChange: true,
      });
    } else {
      this.setState(
        {
          isBetaQuestionText: value,
        },
        () => {
          this.handleQuestionStyleChange();
        }
      );
    }
  };

  toggleIsTakker = (value) => {
    this.setState(
      {
        isTakker: value,
        selectedCollectionMethod: value ? 'CSV' : null,
        selectedCollectionButton: value,
      },
      () => {
        this.methodQuestions();
      }
    );
  };

  evaluationSeriesHandler(status) {
    const { t } = this.props;

    this.setState({
      isSeries: status,
    });

    if (!status && !this.state.popupShown) {
      NotificationManager.info(
        t('activity.evaluation.method_proceed_warning'),
        '',
        10000 // 10S delay [to read whole message]
      );
      this.setState({ checkBoxDisabled: true });
    }
    this.props.handleEvaluationSeries(status);
  }

  acceptDocInfoWarning = () => {
    this.setState({ confirmDocInfo: false }, () => {
      this.getCustomQuestions();
    });
  };

  cancelDocInfoWarning = () => {
    this.setState({ confirmDocInfo: false }, () => {
      this.props.forceFormReset();
    });
  };

  acceptQuestionTextChange = () => {
    this.setState(
      {
        confirmQuestionTextChange: false,
        isBetaQuestionText: this.state.isBetaQuestionTextTemp,
      },
      () => {
        this.handleQuestionStyleChange();
      }
    );
  };

  cancelQuestionTextChange = () => {
    this.setState({ confirmQuestionTextChange: false });
  };

  render() {
    const {
      isBetaQuestionText,
      selectedResponse,
      selectedMethod,
      confirmDocInfo,
      confirmQuestionTextChange,
      selectedCollectionMethod,
      modal,
    } = this.state;

    const {
      evaluationMethod,
      currentActivity,
      form,
      helpTips,
      user,
      isSeries,
      setEvalSeriesCount,
      editMode,
      t,
    } = this.props;

    const response = unionBy(evaluationMethod, 'response_id');

    const methods =
      filter(
        evaluationMethod,
        (item) =>
          item.response_id === selectedResponse &&
          item.method_id !== 'Intercept'
      ) || [];

    const getQuestions = this.getPlanQuestions();
    const questions =
      this.getPlanQuestionsTrimmedAndSortedByObjective(getQuestions);

    return (
      <div className="evalPlan-question">
        <div className="outputs-col-div">
          <Confirm
            open={confirmDocInfo}
            onCancel={this.cancelDocInfoWarning}
            onConfirm={this.acceptDocInfoWarning}
            header={t('common.warning_shriek')}
            content={t('activity.evaluation.documentation_changes_warning')}
            size="tiny"
          />

          <Confirm
            open={confirmQuestionTextChange}
            onCancel={this.cancelQuestionTextChange}
            onConfirm={this.acceptQuestionTextChange}
            header={t('common.warning_shriek')}
            content={t('activity.evaluation.std_to_graded_warning')}
            size="tiny"
          />

          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <Grid.Column className="creation-eval-new">
                <div className="evalPlanType-question">
                  {currentActivity.organisation?.gradedQuestions && (
                    <div className="evalPlanTypes">
                      <div className="evaluations-method-label">
                        {t('activity.evaluation.qst_text_choice_heading')}
                      </div>
                      <div className="checkbox-container auto-width qst-text-picker">
                        <div className="button-include">
                          <Button.Group className="btn">
                            <Button
                              type="button"
                              active={isBetaQuestionText}
                              onClick={() => this.toggleBetaQuestionText(true)}
                            >
                              {t('activity.evaluation.qst_text_choice_graded')}
                            </Button>

                            <Button
                              type="button"
                              active={!isBetaQuestionText}
                              onClick={() => this.toggleBetaQuestionText(false)}
                            >
                              {t('activity.evaluation.qst_text_choice_std')}
                            </Button>
                          </Button.Group>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="evalPlanTypes">
                    <CustomTooltip
                      state={get(user, 'options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '130',
                      }}
                      position="top left"
                      wide="very"
                    >
                      <div className="evaluations-method-label">
                        {t(
                          'activity.evaluation.select_evaluation_respondent_type'
                        )}
                      </div>
                    </CustomTooltip>

                    <AvRadioGroup
                      inline
                      name="response_id"
                      value={selectedResponse}
                      onChange={(e) => {
                        this.handleChangeResponse(e.target.value);
                      }}
                    >
                      {response.length
                        ? response.map((item, i) => {
                            if (item.response_id) {
                              return (
                                <AvRadio
                                  key={i}
                                  label={
                                    <CustomTooltip
                                      state={get(user, 'options.tips')}
                                      contentObject={{
                                        data: helpTips,
                                        key: this.getResponsesKey(
                                          item.response_id
                                        ),
                                      }}
                                      position="top left"
                                      wide="very"
                                    >
                                      <div>
                                        {formatEvaluationResponseLabel(item, t)}
                                      </div>
                                    </CustomTooltip>
                                  }
                                  value={item.response_id}
                                  onChange={(e) => {
                                    this.handleChangeResponse(e.target.value);
                                  }}
                                />
                              );
                            }
                            return null;
                          })
                        : '-'}
                    </AvRadioGroup>
                  </div>
                  <div
                    style={{
                      display:
                        selectedResponse && selectedResponse !== 'Self-assessed'
                          ? 'block'
                          : 'none',
                    }}
                  >
                    <div className="evalPlanTypes">
                      <div className="evaluations-method-label">
                        {t('activity.evaluation.select_evaluation_method')}
                      </div>
                      <AvRadioGroup
                        inline
                        name="method_id"
                        className="evaluation-method-radio"
                        value={selectedMethod}
                        onChange={(e) => {
                          this.handleChangeMethod(e.target.value);
                        }}
                      >
                        {methods
                          ? methods.map((item, i) => {
                              return (
                                <AvRadio
                                  key={i}
                                  label={
                                    <CustomTooltip
                                      state={get(user, 'options.tips')}
                                      contentObject={{
                                        data: helpTips,
                                        key: this.getMethodKey(item.method_id),
                                      }}
                                      position="top left"
                                      wide="very"
                                    >
                                      <div>{item.method}</div>
                                    </CustomTooltip>
                                  }
                                  value={item.method_id}
                                  onChange={(e) => {
                                    this.handleChangeMethod(e.target.value);
                                  }}
                                />
                              );
                            })
                          : null}
                      </AvRadioGroup>
                    </div>

                    {['Proxy', 'Expert'].includes(selectedResponse) &&
                      selectedMethod === 'Interview' && (
                        <div className="evalPlanTypes">
                          {/* TAK-2051b - until we have support hide the age group checkboxes */}
                          <div className="evaluations-method-label">
                            (
                            {t('activity.evaluation_plan.underage_coming_soon')}
                            )
                          </div>

                          {/***************
                        <div className="evaluations-method-label">
                          {t(
                            'activity.evaluation_plan.underage_participants_by_proxy'
                          )}
                        </div>

                        <div className="checkbox-padding takker-checkbox checkbox-ctr">
                          <input type="checkbox" id="proxy_age_6_9" disabled />
                          <label htmlFor="proxy_age_6_9" className="ml-2">
                            <div>
                              {t('activity.evaluation_plan.6_9_years_old')}
                            </div>
                          </label>
                        </div>
                        <div className="checkbox-padding takker-checkbox checkbox-ctr">
                          <input type="checkbox" id="proxy_age_10_12" disabled />
                          <label htmlFor="proxy_age_10_12" className="ml-2">
                            <div>
                              {t('activity.evaluation_plan.10_12_years_old')}
                            </div>
                          </label>
                        </div>
                        <div className="checkbox-padding takker-checkbox checkbox-ctr">
                          <input
                            type="checkbox"
                            id="proxy_expert_respondents_only"
                            disabled
                          />
                          <label
                            htmlFor="proxy_expert_respondents_only"
                            className="ml-2"
                          >
                            <div>
                              {t(
                                'activity.evaluation_plan.proxy_respondents_only'
                              )}
                            </div>
                          </label>
                        </div>
                        ****************/}
                        </div>
                      )}
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        <div className="question-width">
          {selectedResponse === 'Self-assessed' ? (
            <div className="show-q">
              {t('activity.evaluation.mgr_assessed_evaluation_message')}
            </div>
          ) : isEmpty(getQuestions) ? null : (
            <Fragment>
              {selectedResponse && selectedMethod ? (
                <>
                  <div className="questions-eval-new">
                    <div className="border-line" />
                    <CustomTooltip
                      state={get(user, 'options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '213',
                      }}
                      position="top left"
                      wide="very"
                    >
                      <div className="question-text">
                        {t('activity.evaluation.questions')}
                      </div>
                    </CustomTooltip>
                  </div>
                  {map(questions, (question, i) => (
                    <ShowQuestion
                      key={i}
                      ref={(c) => (this[`showQuestions${i}`] = c)}
                      question={question}
                      index={i}
                      {...this.props}
                    />
                  ))}
                  <div className="questions-eval-padding">
                    <CustomAccordion
                      headerStyle={{ color: '#EF8123' }}
                      title={t('activity.evaluation.facilitator_notes')}
                      evalPlan={true}
                      children={
                        <FacilitatorNotes
                          getQuestions={getQuestions}
                          {...this.props}
                        />
                      }
                    />
                  </div>
                </>
              ) : null}
              {this.renderBasedCollectionMethod(
                selectedCollectionMethod || 'LINK'
              )}
            </Fragment>
          )}
        </div>

        {(selectedCollectionMethod ||
          selectedResponse === 'Self-assessed' ||
          (form.isSeries && editMode)) && (
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <div className="question-width">
                  <div className="checkbox-title-eval">
                    <Grid.Column mobile={16} tablet={16} computer={7}>
                      <div className="checkbox-padding">
                        {/* {!checkBoxDisabled ? ( // hide series checkbox when user no need it */}
                        <AvCheckboxGroup
                          name="isAllOrganisation"
                          className="eval-checkBox"
                        >
                          <AvCheckbox
                            disabled={form.isSeries} // || checkBoxDisabled
                            label={
                              <CustomTooltip
                                state={get(user, 'options.tips')}
                                contentObject={{
                                  data: helpTips,
                                  key: '5002',
                                }}
                                position="top left"
                                wide="very"
                              >
                                <span>
                                  {t(
                                    'activity.evaluation.create_multi_stage_evaluation_series'
                                  )}
                                </span>
                              </CustomTooltip>
                            }
                            checked={isSeries || (editMode && form.isSeries)}
                            onChange={() => {
                              this.state.isSeries
                                ? this.evaluationSeriesHandler(
                                    !this.state.isSeries
                                  )
                                : this.toggle();
                            }}
                          />
                        </AvCheckboxGroup>
                        {/* ) : (
                          '' */}
                        {/* )} */}
                      </div>

                      {/* keep the field mounted at all times so it doesn't unregister during
                          rapid toggles (which can lead to the form attempting to validate a
                          missing input and crashing with "input.validations" errors). toggle
                          visibility via CSS and control the requirement through the validator. */}
                      <AvField
                        style={{
                          display: isSeries || form.isSeries ? 'block' : 'none',
                        }}
                        placeholder={t(
                          'activity.evaluation.how_many_times_placeholder'
                        )}
                        className="eval-inputs mt-8"
                        name="seriesCount"
                        type="number"
                        min="2"
                        max="15"
                        autoComplete="off"
                        value={editMode && this.props.form.seriesCount}
                        validate={{
                          required: {
                            value: isSeries,
                            errorMessage: t(
                              'activity.evaluation.must_be_minimum_2_evaluations'
                            ),
                          },
                        }}
                        onChange={(e) => setEvalSeriesCount(e.target.value)}
                      />
                    </Grid.Column>
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}

        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          size="small"
        >
          <Modal.Header>{t('activity.evaluation.confirmation')}</Modal.Header>
          <Modal.Content>
            <p>
              {t('activity.evaluation.do_you_intend_to_survey_same_people')}
            </p>
          </Modal.Content>
          <Modal.Actions>
            <div className="button-flex">
              <Button
                onClick={() => {
                  this.setState({ popupShown: false }, () => {
                    this.evaluationSeriesHandler(false);
                    this.toggle();
                  });
                }}
                className="Secondary-Button"
              >
                {t('actions.no')}
              </Button>
              <Button
                onClick={() => {
                  this.setState({ popupShown: true });
                  this.evaluationSeriesHandler(true);
                  this.toggle();
                }}
                className="Primary-Button"
              >
                {t('actions.yes')}
              </Button>
            </div>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

class FacilitatorNotes extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      displayNotes: false,
    };
  }

  render() {
    const { getQuestions, currentActivity } = this.props;
    const note = UserTextService.replaceStdPlaceholders(
      currentActivity,
      getQuestions?.facilitatorNote
    );

    if (!note) {
      return null;
    }

    return (
      <Grid.Row className="evalPlan-question">
        <div className="show-facilitator">
          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: note,
              }}
            />
          </div>
        </div>
      </Grid.Row>
    );
  }
}

class ShowQuestion extends PureComponent {
  constructor(props) {
    super(props);
    this.contentEditable = createRef();
    this.state = {
      questionNew: {
        methodHeading: '',
        heading: '',
        question1: '',
        question2: '',
      },
      questionNewStash: null,
      questionStyleChange: false,
    };
  }

  componentDidMount() {
    this.setQuestion();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.question, this.props.question)) {
      this.setQuestion();
    }
  }

  setQuestion() {
    const { question, currentActivity, index } = this.props;
    let questionNew = {
      ...question,
      methodHeading:
        index === 0
          ? UserTextService.replaceStdPlaceholders(
              currentActivity,
              question.methodHeading
            )
          : null,
      heading: UserTextService.replaceStdPlaceholders(
        currentActivity,
        question.heading
      ),
    };

    this.setState({ questionNew }, () => {
      // setQuestion() is called from componentDidUpdate() when
      // this.props.question changes, so we need to see if the
      // change has occurred because of a question style change.
      // If so, try and transfer the placeholders in the previous
      // question text.
      let updated = false;
      const qstNew = cloneDeep(this.state.questionNew);

      if (this.state.questionStyleChange) {
        // check that we have valid data for questionNew and questionNewStash
        if (this.state.questionNewStash && this.state.questionNew?.question1) {
          const qstPrev = this.state.questionNewStash;
          for (const key of [
            'methodHeading',
            'heading',
            'question1',
            'question2',
          ]) {
            const replaceInfo = UserTextService.transferAllPlaceholders(
              qstPrev[key],
              qstNew[key]
            );
            if (!replaceInfo.updated) {
              continue;
            }
            qstNew[key] = replaceInfo.text;
            updated = true;
          }
        }

        // update state: reset style change fields, and update "questioNew" if necessary
        const newState = {
          questionNewStash: null,
          questionStyleChange: false,
        };
        if (updated) {
          newState.questionNew = qstNew;
        }
        this.setState(newState);
      }
    });
  }

  prepareForQuestionStyleChange() {
    this.setState({
      questionNewStash: this.state.questionNew,
      questionStyleChange: true,
    });
  }

  getEvaluationQuestion() {
    return this.state.questionNew;
  }

  addQuestion() {
    const { question } = this.props;
    const methodHeading = document.getElementById(
      `methodHeading${question.outcomeId}`
    );
    const heading = document.getElementById(`heading${question.outcomeId}`);
    const question1 = document.getElementById(`question1${question.outcomeId}`);
    const question2 = document.getElementById(`question2${question.outcomeId}`);

    const questionNew = {
      ...question,
      methodHeading: methodHeading ? methodHeading.innerHTML : '',
      heading: heading ? heading.innerHTML : '',
      question1: question1 ? question1.innerHTML : '',
      question2: question2 ? question2.innerHTML : '',
    };

    this.setState({
      questionNew,
    });
  }

  render() {
    const { questionNew } = this.state;
    const { currentActivity, question, t } = this.props;

    // TODO:i18n this text should NOT be hardcoded like this
    const qualitativeQuestion = questionNew.question2
      ? t('activity.evaluation.tell_us_more_two_ratings')
      : t('activity.evaluation.tell_us_more_one_rating');

    const objective = find(
      currentActivity.objective,
      (o) => o.id === question.objectiveId
    );

    const qstComponentMap = [
      {
        key: 'methodHeading',
        title: t('activity.evaluation.qst_component_method_heading'),
      },
      {
        key: 'heading',
        title: t('activity.evaluation.qst_component_heading'),
      },
      {
        key: 'question1',
        title: t('activity.evaluation.qst_component_question1'),
      },
      {
        key: 'question2',
        title: t('activity.evaluation.qst_component_question2'),
      },
    ];

    return (
      <div className="questions-eval-padding eval-qst-ctr">
        <CustomAccordion
          showQuestion={true}
          title={objective ? objective.outcome.title : '-'}
          headerStyle={{ color: '#000000' }}
          children={
            <div className="show-qst-ctr">
              {qstComponentMap.map(
                (info) =>
                  questionNew.hasOwnProperty(info.key) &&
                  questionNew[info.key] && (
                    <div className="sub-ctr">
                      <div className="sub-heading">{info.title}</div>
                      <div
                        id={`${info.key}${question.outcomeId}`}
                        className="content"
                        onBlur={() => this.addQuestion()}
                        dangerouslySetInnerHTML={{
                          __html:
                            UserTextService.convertGenericPlaceholdersToEditableHtml(
                              questionNew[info.key]
                            ),
                        }}
                      />
                    </div>
                  )
              )}
              <div className="sub-ctr">
                <div className="sub-heading">
                  {t('survey.qualitative_question')}
                </div>
                <div className="content rating-qs">{qualitativeQuestion}</div>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

class CustomQuestionForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { questions, createQuestion, removeQuestion, updateQuestion, t } =
      this.props;

    return (
      <Fragment>
        {map(questions, (ques, i) => {
          return (
            <div className="custom-ques" key={i}>
              <div className="right-trash">
                <div className="remove-icon-eval mt-1">
                  {i === 0 ? null : (
                    <Icon
                      className="eval-qs-remove"
                      name="trash"
                      size="large"
                      onClick={() => removeQuestion(ques.index)}
                    />
                  )}
                </div>
              </div>

              <AvField
                name={`Question_${i}`}
                className="custom-question-input"
                placeholder={t('activity.evaluation.enter_your_question')}
                value={ques.label}
                onBlur={(e) =>
                  updateQuestion(ques.index, ques.type, e.target.value)
                }
              />
            </div>
          );
        })}

        <div className="add-icon" onClick={() => createQuestion()}>
          <img className="icons-add" src={addCustom} alt="icon" />
          <div className="add-more-ques">
            {t('activity.evaluation.add_more_questions')}
          </div>
        </div>
        <div className="sep-line-eval" />
      </Fragment>
    );
  }
}

class CustomQuestion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      showEmailInput: false,
      labelEmail: false,
      email: '',
      showFreeQuestion: false,
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  getQuestions() {
    return this.state.questions ? this.state.questions : [];
  }

  haveCustomQstType(qstType) {
    let { questions = [] } = this.state;
    return !isEmpty(questions.find((q) => q.type === qstType));
  }

  getCustomQstLabel(qstType, dflt = '') {
    // TODO:bhu get rid of the console dumps once we're happy it all works
    let { questions = [] } = this.state;
    console.info('~~~~ getCustomQstLabel');
    console.dir(questions, { depth: 3 });
    const resp = questions.find((q) => q.type === qstType)?.label ?? dflt;
    console.info(`RESP ${resp}`);
    return resp;
  }

  async componentDidMount() {
    await this.setState({
      questions: get(this.props, 'form.customQuestions', []),
      // showFreeQuestion: get(this.props, 'form.additionalQuestion', false),
      // showEmailInput: get(this.props, 'form.additionalEmail', false),
    });

    // work out showFreeQuestion and showEmailInput dynamically from the
    // actual custom qst info list - do this in a second setState() call
    // as we need the setState() of "questions" to complete above
    await this.setState({
      showFreeQuestion: this.haveCustomQstType('FREE'),
      showEmailInput: this.haveCustomQstType('EMAIL'),
    });
  }

  addFreeQuestion() {
    let questions = cloneDeep(this.state.questions) || [];
    questions.push({
      type: 'FREE',
      label: '',
    });
    this.setState({
      questions,
    });
  }

  createQuestion() {
    const customQuestions = filter(
      this.state.questions,
      (e) => e.type === 'FREE'
    );
    if (!isEmpty(customQuestions) && size(customQuestions) === 1) {
      this.setState({
        modal: true,
      });
    } else {
      this.addFreeQuestion();
    }
  }

  removeQuestion(index) {
    let questions = cloneDeep(this.state.questions) || [];
    questions.splice(index, 1);
    this.setState({
      questions,
    });
  }

  updateQuestion(index, type, value) {
    let questions = cloneDeep(this.state.questions) || [];
    if (questions[index].type === type) {
      questions[index].label = value;
    }
    this.setState({
      questions,
    });
  }

  setQuestion(type) {
    const { t } = this.props;

    switch (type) {
      case 'FREE':
        return '';
      case 'AGE':
        return t('activity.evaluation.what_is_your_age');
      case 'POSTCODE':
        return t('activity.evaluation.what_is_your_postcode');
      default:
        return '';
    }
  }

  onChange(type, check) {
    let { questions: ques } = this.state;

    if (check) {
      if (type === 'FREE')
        this.setState({
          showFreeQuestion: true,
        });
      else {
        if (type === 'EMAIL') {
          this.setState({ showEmailInput: true });
        }
      }
      ques.push({
        type: type,
        label: this.setQuestion(type),
      });
    } else {
      if (type === 'FREE')
        this.setState({
          showFreeQuestion: false,
        });
      else {
        if (type === 'EMAIL') {
          this.setState({ showEmailInput: false });
        }
      }

      ques = filter(ques, (o) => {
        return o.type !== type;
      });
    }

    this.setState({
      questions: ques,
    });
  }

  onEmail(value) {
    let { questions = [] } = this.state;
    let email = find(questions, (question) => question.type === 'EMAIL');
    if (email) {
      email.label = value;
      this.setState({
        questions,
      });
    }
  }

  render() {
    const {
      questions = [],
      modal,
      showFreeQuestion,
      showEmailInput,
    } = this.state;

    /***********
    const questionDefaultValue = find(
      questions,
      (question) => question.type === 'EMAIL'
    );
    ***********/

    const { helpTips, user, t } = this.props;

    return (
      <>
        <div className="evalPlan-question">
          <CustomTooltip
            state={get(user, 'options.tips')}
            contentObject={{
              data: helpTips,
              key: '214',
            }}
            position="top left"
            wide="very"
          >
            <div className="question-text">
              {t('activity.evaluation.custom_questions')}
            </div>
          </CustomTooltip>

          <Fragment>
            <div className="av-padding">
              <div className="additional-group">
                <div className="custom-ques checkbox-ctr">
                  <AvInput
                    type="checkbox"
                    name="additionalAge"
                    checked={this.haveCustomQstType('AGE')}
                    onChange={(e) => this.onChange('AGE', e.target.checked)}
                  />{' '}
                  <label for="additionalAge">
                    {t('activity.evaluation.what_is_your_age')}
                  </label>
                </div>
                <div className="custom-ques checkbox-ctr">
                  <AvInput
                    type="checkbox"
                    name="additionalPostcode"
                    checked={this.haveCustomQstType('POSTCODE')}
                    onChange={(e) =>
                      this.onChange('POSTCODE', e.target.checked)
                    }
                  />{' '}
                  <label for="additionalPostcode">
                    {t('activity.evaluation.what_is_your_postcode')}
                  </label>
                </div>
                <div className="custom-ques checkbox-ctr">
                  <AvInput
                    type="checkbox"
                    name="additionalQuestion"
                    checked={this.haveCustomQstType('FREE')}
                    onChange={(e) => this.onChange('FREE', e.target.checked)}
                    multiple
                  />{' '}
                  <label for="additionalQuestion">
                    {t('activity.evaluation.custom_question')}
                  </label>
                </div>

                {showFreeQuestion ? (
                  <CustomQuestionForm
                    questions={compact(
                      map(questions, (ques, index) => {
                        if (ques.type === 'FREE') {
                          return {
                            ...ques,
                            index,
                          };
                        }
                      })
                    )}
                    createQuestion={() => this.createQuestion()}
                    removeQuestion={(index) => this.removeQuestion(index)}
                    updateQuestion={(index, type, value) =>
                      this.updateQuestion(index, type, value)
                    }
                    {...this.props}
                  />
                ) : null}

                <div className="custom-ques checkbox-ctr">
                  <AvInput
                    type="checkbox"
                    name="additionalEmail"
                    checked={this.haveCustomQstType('EMAIL')}
                    onChange={(e) => this.onChange('EMAIL', e.target.checked)}
                  />
                  <label for="additionalEmail">
                    {t('activity.evaluation.request_email')}
                  </label>
                </div>
              </div>

              {/* Always render the email prompt field (so it stays registered) and
                  simply hide/show it. Also correct the validator: the required rule
                  expects a boolean; the regex belongs in a pattern rule. */}
              <div
                className="label-email"
                style={{ display: showEmailInput ? 'block' : 'none' }}
              >
                <AvField
                  validate={{
                    required: {
                      value: !!showEmailInput,
                      errorMessage: t(
                        'activity.evaluation.respondent_email_message_required'
                      ),
                    },

                    // bhu: why on earth does a label for an email request field
                    // have to be restricted to alphanum? not even spaces??? WEIRD
                    // TODO: use a proper regex for emails
                    /*
                    pattern: {
                      value: '^[A-Za-z0-9]+$',
                      errorMessage: 'Only alphanumeric characters allowed',
                    },
                    */
                  }}
                  name="EmailField"
                  value={this.getCustomQstLabel('EMAIL')}
                  placeholder={t(
                    'activity.evaluation.enter_request_for_respondent_email'
                  )}
                  className="email-active"
                  onBlur={(e) => this.onEmail(e.target.value)}
                />
              </div>
            </div>
          </Fragment>

          <Modal
            open={modal}
            onOpen={() => this.toggle()}
            closeIcon={
              <Icon
                onClick={() => this.toggle()}
                name="close"
                className="closeicon"
              />
            }
            size="small"
          >
            <Modal.Header>{t('activity.evaluation.confirmation')}</Modal.Header>
            <Modal.Content>
              <p>{t('activity.evaluation.additional_questions_warning')}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={() => this.toggle()} className="modal-cancel">
                {t('actions.cancel')}
              </Button>
              <Button
                onClick={() => {
                  this.addFreeQuestion();
                  this.toggle();
                }}
                className="modal-proceed"
              >
                {t('actions.confirm')}
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      </>
    );
  }
}

class EvaluationPlanForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedObj: null,
      totalParticipants: 0,
      groupSelected: false,
      sampleSize: 0,
      loading: false,
      selectedObjective: props.form.objectives,
      selectedGroups: props.form.participantGroups,
      collectionMethodButton: false,
      getSelectResponseValue: false,
      groupType: null,
      isSeries: false,
      seriesCount: 0,
      autoGroupSelectionApplied: false,
    };
  }

  getIsBetaQuestionText() {
    return this.evaluationPlanRespond?.getIsBetaQuestionText();
  }

  getIsTakker() {
    return this.evaluationPlanRespond?.getIsTakker();
  }

  getSelectedMethod() {
    return this.evaluationPlanRespond?.getSelectedMethod();
  }

  getSelectedCollectionMethod() {
    return this.evaluationPlanRespond?.getSelectedCollectionMethod();
  }

  getSelectedResponse() {
    return this.evaluationPlanRespond?.getSelectedResponse();
  }

  getCustomQuestions() {
    return this.evaluationPlanRespond?.getCustomQuestions();
  }

  getEvaluationQuestion() {
    return this.evaluationPlanRespond?.getEvaluationQuestion();
  }

  getCustomSuccessMessage() {
    return this.evaluationPlanRespond?.getCustomSuccessMessage();
  }

  getSelectedObjective() {
    return this.state.selectedObjective || [];
  }

  getSelectedGroups() {
    return this.state.selectedGroups || [];
  }

  getSampleSize() {
    return this.state.sampleSize;
  }

  getTotalParticipants() {
    return this.state.totalParticipants;
  }

  getMultiStageEvalCount() {
    return this.state.seriesCount;
  }

  getIsMultiStageEval() {
    return this.state.isSeries;
  }

  componentDidMount() {
    const { t } = this.props;
    try {
      const { getEvaluationGroups, currentActivity } = this.props;
      this.setState(
        {
          // not sure why these state vars were only seeded here
          // and not in the ctor as we have props in the ctor we can access
          // initial values from...anyways, I have added this initialisation
          // to the ctor as well, to stop "flashing" of field values onscreen
          // when loading an evaluation plan for editing
          selectedObjective: this.props.form.objectives,
          selectedGroups: this.props.form.participantGroups,
        },
        () => {
          const participants = get(this.props, 'form.participants', []);
          if (!isEmpty(participants)) {
            const [one] = participants;
            this.setState({
              groupType: get(one, 'targetGroup.type', null),
            });
          }
          // evaluationGroupSelected may already be populated in Redux (e.g.
          // the parent evaluation page fetched it before this form mounted),
          // so check now rather than only waiting for a future prop change.
          this.maybeAutoSelectSoleGroup();
        }
      );
      this.setSizes();
      getEvaluationGroups(currentActivity.id);
    } catch (error) {
      NotificationManager.error(t('common.something_went_wrong'));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.evaluationGroupSelected !== this.props.evaluationGroupSelected
    ) {
      this.maybeAutoSelectSoleGroup();
    }
  }

  // Auto-select the sole evaluation group for a brand new plan, once. Editing
  // an existing plan, having 2+ groups, or already having a selection (e.g.
  // the user has already made/undone a choice) leaves it up to the user.
  maybeAutoSelectSoleGroup() {
    const { editMode, evaluationGroupSelected } = this.props;
    if (
      editMode ||
      this.state.autoGroupSelectionApplied ||
      isEmpty(evaluationGroupSelected) ||
      evaluationGroupSelected.length !== 1 ||
      !isEmpty(this.state.selectedGroups)
    ) {
      return;
    }
    const [group] = evaluationGroupSelected;
    this.setState({ autoGroupSelectionApplied: true });
    this.evaluationGroup(
      group.id,
      getEvaluationParticipantCount(group),
      true,
      group.type
    );
  }

  setSizes() {
    const { form } = this.props;
    if (!isEmpty(form.participants)) {
      let sampleSizeLabel = 0;
      let confidenceLevel = 1.96;
      let confidenceInterval = 5;

      let sampleSize =
        (confidenceLevel * confidenceLevel * 0.25) /
        ((confidenceInterval / 100) * (confidenceInterval / 100));

      const totalParticipants = sum(
        map(form.participants, (group) =>
          getEvaluationParticipantCount(group, form)
        )
      );

      let population = Math.floor(totalParticipants);
      if (population !== 0) {
        sampleSize = sampleSize / (1 + (sampleSize - 1) / population);
        sampleSizeLabel = Math.floor(sampleSize);
      }

      this.setState({
        totalParticipants,
        sampleSize: sampleSizeLabel,
      });
    }
  }

  handleChangeObjective(value, check) {
    const newValue = parseInt(value);
    const selectedObjective = [...this.state.selectedObjective];

    var index = selectedObjective.indexOf(newValue);

    if (check === true) {
      selectedObjective.push(newValue);
      this.setState({
        selectedObjective: uniq(selectedObjective),
      });
    } else {
      const selectedObjective = [...this.state.selectedObjective];
      if (index > -1) {
        selectedObjective.splice(index, 1);
      }

      this.setState({
        selectedObjective: uniq(selectedObjective),
      });
    }
  }

  async handleChangeGroups(value, check, groupType) {
    const newValue = parseInt(value);
    const selectedGroups = [...this.state.selectedGroups];

    var index = selectedGroups.indexOf(newValue);

    if (check === true) {
      selectedGroups.push(newValue);
      this.setState({
        selectedGroups: uniq(selectedGroups),
        groupType,
      });
    } else {
      const selectedGroups = [...this.state.selectedGroups];
      if (index > -1) {
        selectedGroups.splice(index, 1);
      }

      this.setState({
        selectedGroups: uniq(selectedGroups),
        groupType,
      });
    }
  }

  handleEvaluationSeries = (status) => {
    this.setState({
      isSeries: status,
    });
  };

  setEvalSeriesCount = (count) => {
    this.setState({
      seriesCount: count,
    });
  };

  async evaluationGroup(value, size, check, groupType) {
    await this.handleChangeGroups(value, check, groupType);

    let sampleSizeLabel = 0;
    let confidenceLevel = 1.96;
    let confidenceInterval = 5;

    let sampleSize =
      (confidenceLevel * confidenceLevel * 0.25) /
      ((confidenceInterval / 100) * (confidenceInterval / 100));

    const totalParticipants = check
      ? this.state.totalParticipants + parseInt(size)
      : this.state.totalParticipants - parseInt(size);

    let population = Math.floor(totalParticipants);

    if (population !== 0) {
      sampleSize = sampleSize / (1 + (sampleSize - 1) / population);
      sampleSizeLabel = Math.floor(sampleSize);
    }

    this.setState({
      totalParticipants,
      sampleSize: sampleSizeLabel,
      loading: true,
    });

    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 500);
  }

  getCollectionMethodForButton = (value) => {
    if (value === true) {
      this.setState({
        collectionMethodButton: true,
      });
    } else {
      return null;
    }
  };

  getSelfAssessedResponse = (value) => {
    if (value === 'Self-assessed') {
      this.setState({
        getSelectResponseValue: true,
      });
    } else {
      this.setState({
        getSelectResponseValue: false,
      });
    }
  };

  render() {
    const {
      form,
      currentActivity,
      editMode,
      methods,
      evaluationGroupSelected,
      groupParticipantLoading,
      goBack,
      helpTips,
      user,
      t,
    } = this.props;

    const {
      sampleSize,
      totalParticipants,
      loading,
      selectedObjective,
      selectedGroups,
      groupType,
      collectionMethodButton,
      getSelectResponseValue,
    } = this.state;

    return (
      <div className="create-evaluation-plan">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={6}>
              <AvField
                label={t('activity.evaluation.evaluation_plan_name')}
                className="eval-inputs"
                name="name"
                defaultValue={form.name}
                type="text"
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'activity.evaluation.evaluation_plan_name_required'
                    ),
                  },
                }}
                autoComplete="off"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={6}>
              <AvField
                label={
                  <CustomTooltip
                    state={get(user, 'options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '222',
                    }}
                    position="top left"
                    wide="very"
                  >
                    <span style={{ cursor: 'default' }}>
                      {t('activity.evaluation.survey_title')}
                    </span>
                  </CustomTooltip>
                }
                className="eval-inputs"
                name="surveyTitle"
                defaultValue={form.surveyTitle || currentActivity.name}
                type="text"
                validate={{
                  required: {
                    value: true,
                    errorMessage: t('activity.evaluation.survey_title_reqd'),
                  },
                }}
                autoComplete="off"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="participant-group-div">
                <div className="checkbox-title-eval">
                  <CustomTooltip
                    state={get(user, 'options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '210',
                    }}
                    position="top left"
                    wide="very"
                  >
                    <div style={{ cursor: 'default' }}>
                      {size(currentActivity.objective) === 1
                        ? t('common.objective')
                        : t('common.objectives')}
                    </div>
                  </CustomTooltip>
                  <div className="eval-checkBox">
                    {!isEmpty(currentActivity.objective) ? (
                      <Grid className="eval-check">
                        {map(currentActivity.objective, (objective, i) => {
                          return (
                            <Grid.Column
                              key={i}
                              mobile={16}
                              tablet={16}
                              computer={6}
                            >
                              <div className="checkbox-padding checkbox-ctr">
                                <input
                                  type="checkbox"
                                  id={`objective_${objective.id}`}
                                  checked={selectedObjective.includes(
                                    objective.id
                                  )}
                                  onChange={(e) => {
                                    this.handleChangeObjective(
                                      objective.id,
                                      e.target.checked
                                    );
                                  }}
                                />
                                <label htmlFor={`objective_${objective.id}`}>
                                  {get(objective, 'outcome.title', '-')}
                                </label>
                              </div>
                            </Grid.Column>
                          );
                        })}
                      </Grid>
                    ) : (
                      <em>{t('activity.evaluation.no_objective_selected')}</em>
                    )}
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>{' '}
          <Grid.Row>
            <Grid.Column>
              <div className="participant-group-div">
                <div className="checkbox-title-eval">
                  <CustomTooltip
                    state={get(user, 'options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '211',
                    }}
                    position="top left"
                    wide="very"
                  >
                    <div style={{ cursor: 'default' }}>
                      {t('activity.evaluation.select_evaluation_group')}
                    </div>
                  </CustomTooltip>
                  <div className="eval-checkBox">
                    {!isEmpty(evaluationGroupSelected) ? (
                      <Grid className="eval-check">
                        {compact(
                          map(evaluationGroupSelected, (group, i) => {
                            let disabled = false;
                            if (
                              groupType === 'FIELD' &&
                              group.type === 'GROUP'
                            ) {
                              disabled = true;
                            }
                            if (
                              groupType === 'GROUP' &&
                              group.type === 'FIELD'
                            ) {
                              disabled = true;
                            }
                            if (isEmpty(selectedGroups)) {
                              disabled = false;
                            }
                            return (
                              <Grid.Column
                                key={i}
                                mobile={16}
                                tablet={16}
                                computer={6}
                              >
                                <div className="checkbox-padding checkbox-ctr">
                                  <input
                                    type="checkbox"
                                    id={`group_${group.id}`}
                                    disabled={disabled}
                                    checked={selectedGroups.includes(group.id)}
                                    onChange={(e) => {
                                      this.evaluationGroup(
                                        group.id,
                                        getEvaluationParticipantCount(group),
                                        e.target.checked,
                                        group.type
                                      );
                                    }}
                                  />
                                  <label htmlFor={`group_${group.id}`}>
                                    {get(group, 'name', '-')}
                                  </label>
                                </div>
                              </Grid.Column>
                            );
                          })
                        )}
                      </Grid>
                    ) : (
                      <em>
                        {t('activity.evaluation.no_evaluation_group_to_select')}
                      </em>
                    )}
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
          {SHOW_RECOMMENDED_SAMPLE_SIZE ? (
            <Grid.Row>
              <Grid.Column>
                <div className="eval-mtd-div">
                  <div className="desc-div">
                    <CustomTooltip
                      state={get(user, 'options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '128',
                      }}
                      position="top left"
                      wide="very"
                    >
                      <div className="sample-text">
                        {t('activity.evaluation.recommended_sample_size')}
                      </div>
                    </CustomTooltip>
                    {loading ? (
                      <Loader active inline className="evaluation-div-loader" />
                    ) : (
                      <div>
                        <label className="description">
                          <Trans
                            i18nKey="activity.evaluation.sample_size_description"
                            values={{
                              totalParticipants,
                              sampleSize,
                            }}
                            components={{
                              b: <strong />,
                            }}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          ) : null}
        </Grid>

        {!isEmpty(selectedObjective) && (
          <EvaluationPlanRespondent
            ref={(c) => (this.evaluationPlanRespond = c)}
            selectedObjective={selectedObjective}
            evaluationMethod={methods}
            isSeries={this.state.isSeries}
            getCollectionMethodForButton={this.getCollectionMethodForButton}
            getSelfAssessedResponse={this.getSelfAssessedResponse}
            setEvalSeriesCount={this.setEvalSeriesCount}
            handleEvaluationSeries={this.handleEvaluationSeries}
            {...this.props}
          />
        )}

        <div className="participant-group-div">
          {editMode ? null : (
            <div>
              {collectionMethodButton || getSelectResponseValue ? (
                <div className="button-survey-new">
                  <Button
                    className="Secondary-Button"
                    onClick={(type) => goBack()}
                    type="button"
                  >
                    {t('actions.back')}
                  </Button>
                  <div>
                    <Button
                      type="submit"
                      className="Primary-Button"
                      loading={groupParticipantLoading}
                      disabled={groupParticipantLoading}
                    >
                      {t('activity.evaluation.save_evaluation_plan')}
                    </Button>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>

        {editMode ? (
          <div className="button-survey-new">
            <div
              className="Secondary-Button"
              // type="button"
              onClick={() => goBack()}
            >
              {t('actions.back')}
            </div>
            <div>
              <Button
                type="submit"
                className="Primary-Button"
                loading={groupParticipantLoading}
                disabled={groupParticipantLoading}
              >
                {t('activity.evaluation.update_evaluation_plan')}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export class DeleteEvalPlan extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleGroupDelete() {
    const {
      evalPlanId,
      currentActivity,
      deleteEvaluationPlan,
      resetForm,
      seriesParentId,
    } = this.props;
    let isSeries = false;

    if (seriesParentId) {
      isSeries = true;
    } else {
      isSeries = false;
    }

    deleteEvaluationPlan(currentActivity.id, evalPlanId, isSeries);
    this.toggle();
    resetForm();
  }

  render() {
    const { modal } = this.state;
    const { evaluationLoader, trigger, seriesParentId, t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={trigger}
      >
        <Modal.Header>
          {t('activity.evaluation.delete_confirmation')}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t('activity.evaluation.delete_survey_confirmation', {
              type: seriesParentId
                ? t('activity.evaluation.survey_series')
                : t('activity.evaluation.survey'),
            })}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.toggle()} className="modal-cancel">
            {t('actions.cancel')}
          </Button>
          <Button
            className="modal-proceed"
            onClick={() => this.handleGroupDelete()}
            content={t('actions.delete')}
            type="submit"
            loading={evaluationLoader}
            disabled={evaluationLoader}
            negative
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

class ShowEvaluationModelQuestion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getOrderedEvaluationQuestions() {
    const { evalPlans } = this.props;

    // make sure ordered by outcome id
    return orderBy(
      evalPlans?.evaluationQuestions || [],
      ['outcomeId'],
      ['asc']
    );
  }

  render() {
    const { t } = this.props;

    return (
      <Fragment>
        <CustomAccordion
          showQuestion={true}
          title={t('activity.evaluation.evaluation_questions')}
          headerStyle={{ color: '#000000' }}
          children={
            <div className="show-qs-model">
              <div className="eval-groups-qs">
                {map(this.getOrderedEvaluationQuestions(), (question, i) => {
                  return (
                    <ShowEvaluationQuestion
                      key={i}
                      question={question}
                      index={i}
                    />
                  );
                })}
              </div>
            </div>
          }
        />
      </Fragment>
    );
  }
}

class ViewPlan extends PureComponent {
  calculateSampleSize(evalPlans = []) {
    let sampleSizeLabel = 0;
    let confidenceLevel = 1.96;
    let confidenceInterval = 5;

    let sampleSize =
      (confidenceLevel * confidenceLevel * 0.25) /
      ((confidenceInterval / 100) * (confidenceInterval / 100));

    const totalParticipants = sum(
      map(evalPlans?.participantGroups, (group) =>
        getEvaluationParticipantCount(group, evalPlans)
      )
    );
    let population = Math.floor(totalParticipants);

    if (population !== 0) {
      sampleSize = sampleSize / (1 + (sampleSize - 1) / population);
      sampleSizeLabel = Math.floor(sampleSize);
    }

    return {
      totalParticipants,
      sampleSize: sampleSizeLabel,
    };
  }

  renderQuestions(customQs) {
    const { t } = this.props;
    switch (customQs.type) {
      case 'AGE':
        return t('activity.evaluation.what_is_your_age');
      case 'POSTCODE':
        return t('activity.evaluation.what_is_your_postcode');
      default:
        return customQs.label;
    }
  }

  render() {
    const { evalPlans, getObjective, t } = this.props;
    const { totalParticipants, sampleSize } =
      this.calculateSampleSize(evalPlans);

    return (
      <Fragment>
        <div className="model-view-evaluation">
          <div className="eval-name-model">{evalPlans.name}</div>
          <div className="eval-objective">
            {t('common.objective').toUpperCase()}{' '}
          </div>
          <div className="eval-objective-sub ">{getObjective}</div>
          <div className="eval-objective">
            {t('activity.evaluation.evaluation_groups').toUpperCase()}
          </div>

          <div className="eval-groups">
            {map(evalPlans.participantGroups, (group, i) => {
              return <p key={i}>{group.targetGroup.name}</p>;
            })}
          </div>

          {SHOW_RECOMMENDED_SAMPLE_SIZE ? (
            <Fragment>
              <div className="eval-objective">
                {t('activity.evaluation.recommended_sample_size').toUpperCase()}
              </div>

              <div className="eval-groups">
                <Trans
                  i18nKey="activity.evaluation.sample_size_description"
                  values={{
                    totalParticipants,
                    sampleSize,
                  }}
                  components={{
                    b: <strong />,
                  }}
                />
              </div>
            </Fragment>
          ) : null}

          <div className="eval-participant-type">
            {t('activity.evaluation.evaluation_method').toUpperCase()}
          </div>
          <div className="eval-groups">
            {formatEvaluationResponseLabel(evalPlans.method, t)}
          </div>

          {evalPlans.method.response_id === 'Self-assessed' ? null : (
            <Fragment>
              <div className="eval-participant-type">
                {t(
                  'activity.evaluation.evaluation_respondent_type'
                ).toUpperCase()}{' '}
              </div>
              <div className="eval-groups">{evalPlans.method.method}</div>
              {evalPlans.isTakker ? (
                <Fragment>
                  <div className="eval-participant-type">
                    {t('activity.evaluation.respondent_subset')}
                  </div>
                  <div className="eval-groups">
                    {t('activity.evaluation.respondent_subset_takker')}
                  </div>
                </Fragment>
              ) : null}

              <ShowEvaluationModelQuestion
                evalPlans={evalPlans}
                {...this.props}
              />

              {evalPlans.collectionMethod === 'LINK' ||
              evalPlans.collectionMethod === 'CSV' ? (
                <Fragment>
                  {!isEmpty(evalPlans.customQuestions) ? (
                    <Fragment>
                      <CustomAccordion
                        extraMargin
                        headerStyle={{
                          color: '#EF8123',
                        }}
                        title={t('activity.evaluation.additional_questions')}
                        evalPlan={true}
                        children={
                          <div className="eval-groups-custom-title">
                            {map(evalPlans.customQuestions, (customQs, i) => {
                              return (
                                <div key={i}>
                                  <div className="eval-group-custom">
                                    {i + 1}. {this.renderQuestions(customQs)}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        }
                      />
                    </Fragment>
                  ) : null}
                  <CustomAccordion
                    extraMargin
                    headerStyle={{ color: '#EF8123' }}
                    title={t('activity.evaluation.custom_success_message')}
                    evalPlan={true}
                    children={
                      <div className="show-qs-model">
                        <div className="eval-groups-qs-custom">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: evalPlans.successMessage,
                            }}
                          />
                        </div>
                      </div>
                    }
                  />
                </Fragment>
              ) : null}
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

class ViewEvaluationPlanModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  objectives(item) {
    const { currentActivity } = this.props;
    return compact(
      map(currentActivity.objective, (objective, i) => {
        if (
          !find(item.evaluationQuestions, (e) => e.objectiveId === objective.id)
        ) {
          return null;
        }
        return (
          <div key={i}>
            <div className="eval-groups">
              {get(objective, 'outcome.title', null)}
            </div>
          </div>
        );
      })
    );
  }

  render() {
    const { item, triggerTitle, t } = this.props;
    const { modal } = this.state;

    return (
      <div>
        <Modal
          key={item.id}
          trigger={triggerTitle}
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            {t('activity.evaluation.evaluation_plan')}{' '}
          </Modal.Header>
          <Modal.Content>
            <ViewPlan
              key={item.id}
              evalPlans={item}
              getObjective={this.objectives(item)}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const EvaluationGroup = (props) => {
  const { item } = props;
  return <div className="objective-eval">{item.name}</div>;
};

class EvaluationPlanList extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = this.props;

    this.state = {
      currentPage: 1,
      planPerPage: 5,
      currentPlans: [],
      modal: false,
      item: '',
      columns: [
        {
          width: 4,
          title: (
            <div className="lib-header">
              {t('activity.evaluation.evaluation_plan_name')}
            </div>
          ),
          render: (data) => {
            return (
              <div className="eval-name-plan">
                <label className="desc-title">
                  {formatEvaluationPlanDisplayName(data)}
                </label>
                <div>
                  {get(data, 'isDisabled', true) ? (
                    <div className="isDisabled-eval">
                      <div className="text-dis">
                        {' '}
                        {get(data, 'haveResponses', false)
                          ? t('activity.evaluation.closed')
                          : t('common.disabled')}
                      </div>
                    </div>
                  ) : get(data, 'seriesParentId', null) &&
                    !getPageDisable(
                      props.currentActivity,
                      props.user,
                      props.currentState
                    ) ? ( // <- need to check visibility of add subtitle
                    <Button
                      onClick={() => {
                        this.props.toggleSubtitleModal(true, data);
                      }}
                      className="btn-add-subtitle"
                    >
                      {get(data, 'seriesSubtitle', null) ? (
                        <>
                          <Icon name="edit" />{' '}
                          {get(data, 'seriesSubtitle', null)}
                        </>
                      ) : (
                        <>
                          <Icon name="plus" />{' '}
                          {t('activity.evaluation.add_subtitle')}
                        </>
                      )}
                    </Button>
                  ) : get(data, 'seriesSubtitle', null) ? (
                    <span className="series-subtitle-badge">
                      {get(data, 'seriesSubtitle', null)}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            );
          },
        },
        {
          width: 5,
          title: t('common.objective'),
          render: (data) => {
            return <div>{this.objectives(data)}</div>;
          },
        },
        {
          width: 3,
          title: t('activity.evaluation.evaluation_groups'),
          render: (data) => {
            return size(this.evaluationGroups(data)) > 3 ? (
              <SeeMore
                minCount={3}
                dataSet={this.evaluationGroups(data)}
                CustomComponent={EvaluationGroup}
              />
            ) : (
              <div>
                {map(this.evaluationGroups(data), (g, i) => {
                  return (
                    <div key={i} className="objective-eval">
                      {g.name}
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            const { t } = this.props;
            const seriesParentId = get(data, 'seriesParentId', null);
            const evaluationId = get(data, 'id', null);
            return (
              <div>
                <ViewEvaluationPlanModal
                  triggerTitle={
                    <div className="view-plan">
                      {' '}
                      {seriesParentId
                        ? seriesParentId === evaluationId // only visible view for parent series
                          ? t('activity.evaluation.view_series')
                          : ''
                        : t('activity.evaluation.view_the_plan')}
                    </div>
                  }
                  item={data}
                  {...this.props}
                />
              </div>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            const { editPlan, currentActivity, user, currentState, t } =
              this.props;
            const preview = true;
            const surveyLink = getPreviewSurveyLink(
              currentActivity.id,
              data.id,
              map(
                get(data, 'evaluationQuestions', []),
                (evaluation) => evaluation.objectiveId
              ),
              preview
            );
            const seriesParentId = get(data, 'seriesParentId', null);
            const evaluationId = get(data, 'id', null);
            return (
              <div>
                {getPageDisable(currentActivity, user, currentState) ? (
                  <div>
                    {(data.collectionMethod === 'LINK' ||
                      data.collectionMethod === 'CSV') &&
                    !seriesParentId ? (
                      <a
                        href={surveyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {' '}
                        <div className="preview-the-plan">
                          {t('activity.evaluation.preview_survey')}
                        </div>{' '}
                      </a>
                    ) : seriesParentId && seriesParentId === evaluationId ? (
                      <a
                        href={surveyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {' '}
                        <div className="preview-the-plan">
                          {t('activity.evaluation.preview_survey')}
                        </div>{' '}
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <div>
                    {get(data, 'isDisabled', true) &&
                    // && (get(data, 'haveResponses', false) <- future changes
                    seriesParentId === evaluationId ? (
                      <div className="disabled-eval-edit-plan">
                        {seriesParentId
                          ? t('specific_actions.edit_series')
                          : t('activity.evaluation.edit_the_plan')}
                      </div>
                    ) : (
                      <div
                        className="edit-the-plan"
                        onClick={() => editPlan(data)}
                      >
                        {seriesParentId
                          ? seriesParentId === evaluationId // only visible view for parent series
                            ? t('specific_actions.edit_series')
                            : ''
                          : t('activity.evaluation.edit_the_plan')}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            const { resetForm, currentActivity, user, currentState, t } =
              this.props;
            const preview = true;
            const surveyLink = getPreviewSurveyLink(
              currentActivity.id,
              data.id,
              map(
                get(data, 'evaluationQuestions', []),
                (evaluation) => evaluation.objectiveId
              ),
              preview
            );
            const seriesParentId = get(data, 'seriesParentId', null);
            const evaluationId = get(data, 'id', null);
            return (
              <div className="dropdown-eval-plans">
                {getPageDisable(currentActivity, user, currentState) ||
                (seriesParentId && seriesParentId !== evaluationId) ? null : (
                  <Dropdown
                    icon="ellipsis vertical"
                    direction="left"
                    inline
                    selectOnBlur={false}
                  >
                    <Dropdown.Menu>
                      {data.collectionMethod === 'LINK' ||
                      data.collectionMethod === 'CSV' ? (
                        <Dropdown.Item
                          as="a"
                          href={surveyLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div>{t('activity.evaluation.preview_survey')}</div>
                        </Dropdown.Item>
                      ) : null}

                      {(seriesParentId && evaluationId === seriesParentId) ||
                      !seriesParentId ? (
                        <DeleteEvalPlan
                          evalPlanId={data.id}
                          {...this.props}
                          resetForm={resetForm}
                          seriesParentId={seriesParentId}
                          trigger={
                            <Dropdown.Item
                              // text="Remove"
                              className="dropdown-customItem"
                            >
                              <div className="remove-activity">
                                {evaluationId === seriesParentId &&
                                seriesParentId ? (
                                  <span>
                                    {t('activity.evaluation.remove_series')}
                                  </span>
                                ) : (
                                  <span>{t('actions.remove')}</span>
                                )}
                              </div>
                            </Dropdown.Item>
                          }
                        />
                      ) : (
                        ''
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            );
          },
        },
      ],
    };
  }

  componentDidMount() {
    const { currentActivity } = this.props;
    const { planPerPage } = this.state;

    this.setState({
      currentPlans: !isEmpty(currentActivity.evaluationPlans)
        ? currentActivity.evaluationPlans.slice(0, planPerPage)
        : 0,
    });
  }

  componentDidUpdate(prevProps) {
    const { currentActivity } = this.props;
    if (
      prevProps.currentActivity.evaluationPlans !==
      currentActivity.evaluationPlans
    ) {
      const { planPerPage } = this.state;
      currentActivity.evaluationPlans &&
        this.setState({
          currentPlans: !isEmpty(currentActivity.evaluationPlans)
            ? currentActivity.evaluationPlans.slice(0, planPerPage)
            : 0,
        });
    }

    if (prevProps.seeMore !== this.state.seeMore) {
      this.evaluationGroups(this.state.item);
    }
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  objectives(item) {
    const { currentActivity } = this.props;
    return compact(
      map(currentActivity.objective, (objective, i) => {
        if (
          !find(item.evaluationQuestions, (e) => e.objectiveId === objective.id)
        ) {
          return null;
        }
        return (
          <div className="objective-eval" key={i}>
            {get(objective, 'outcome.title', null)}
          </div>
        );
      })
    );
  }

  evaluationGroups(item) {
    let groups = [];
    for (const evalPlan of item.participantGroups) {
      let groupName = get(evalPlan, 'targetGroup.name', null);
      groups.push({ name: groupName });
    }

    return groups;
  }

  showOtherGroups(groups) {
    return compact(
      map(groups, (group, i) => {
        return (
          <div key={i}>
            <div className="objective-bg">{get(group, 'name', null)}</div>
          </div>
        );
      })
    );
  }

  pageChange(page) {
    const { currentActivity } = this.props;
    const { planPerPage } = this.state;

    const lastIndex = page * planPerPage;
    const firstIndex = lastIndex - planPerPage;
    const currentPlans = currentActivity.evaluationPlans.slice(
      firstIndex,
      lastIndex
    );

    this.setState({
      currentPage: page,
      currentPlans,
    });
  }

  updateQuestionText({ beta = false }) {}

  render() {
    const {
      currentActivity,
      changeEvaluationPlanView,
      actPut,
      user,
      currentState,
      t,
    } = this.props;
    const { columns, currentPage, currentPlans, planPerPage } = this.state;
    const noOfPages = Math.ceil(
      currentActivity.evaluationPlans
        ? currentActivity.evaluationPlans.length / planPerPage
        : 0
    );

    return (
      <>
        <CustomSegment
          className="evaluation-plan"
          title={t('activity.evaluation.evaluation_plans')}
          rightHeader={
            <Segment
              loading={actPut['evaluationPlans']}
              disabled={getPageDisable(currentActivity, user, currentState)}
              className="segment-eval-plans actions"
            >
              <div
                onClick={(type) => changeEvaluationPlanView('Add')}
                className="Secondary-Button"
              >
                <Icon name="plus" />
                {t('activity.evaluation.add_new_evaluation_plan')}
              </div>
            </Segment>
          }
          children={
            <Fragment>
              <div className="eval-bg-new">
                <CustomTable
                  header
                  data={currentPlans}
                  columns={columns}
                  pagination
                  handlePaginationChange={(page) => this.pageChange(page)}
                  page={currentPage}
                  noOfPages={noOfPages}
                  customClass="evaluation-table"
                  keyExtractor={(item, index) => item.id}
                />
              </div>
            </Fragment>
          }
        />
      </>
    );
  }
}

class MainEvalPlan extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showCreatePlan: false,
      showCreatWarring: false,
      form: this.getDfltForm(),
      checkForm: this.getDfltForm(),
      editMode: false,
      loadEditing: false,
      modalShow: false,
      navigationModal: false,
      editNewForm: {},
      enterKey: false,
      subtitleModal: false,
      subtitleDeleteModal: false,
      subtitleDeleteLoading: false,
      seriesSubtitle: '',
      currentEvaluation: {},
    };
  }

  componentWillUnmount() {
    this.resetForm();
  }

  componentDidMount() {
    try {
      const { currentActivity, getEvaluationGroups, getEvaluationPlans } =
        this.props;
      getEvaluationPlans(currentActivity.id);
      getEvaluationGroups(currentActivity.id);
    } catch (error) {
      console.error(error);
    }
  }

  onKeyPress(event) {
    // trap ENTER to bypass form submission this way
    if (event.which === 13) {
      event.preventDefault();
    }
  }

  componentDidUpdate() {
    try {
      const { getEvaluationPage, isEvaluationPageOpen } = this.props;
      if (!this.state.showCreatePlan) {
        getEvaluationPage && isEvaluationPageOpen && getEvaluationPage(false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async handleValidSubmit(event, values) {
    const {
      t,
      currentActivity,
      methods,
      postEvaluationPlan,
      updateEvaluationPlan,
    } = this.props;

    const { editMode, form } = this.state;

    // Manual validation for fields that use state instead of form model
    const isBetaQuestionText = this.evaluationPlanForm.getIsBetaQuestionText();
    const selectedResponse = this.evaluationPlanForm.getSelectedResponse();
    const selectedMethod = this.evaluationPlanForm.getSelectedMethod();
    const selectedCollectionMethod =
      this.evaluationPlanForm.getSelectedCollectionMethod();
    const selectedObjective = this.evaluationPlanForm.getSelectedObjective();
    const selectedGroups = this.evaluationPlanForm.getSelectedGroups();

    if (!selectedResponse) {
      NotificationManager.error(
        t('activity.evaluation_plan.select_respondent_type')
      );
      return;
    }

    if (selectedResponse !== 'Self-assessed' && !selectedMethod) {
      NotificationManager.error(
        t('activity.evaluation_plan.select_evaluation_method')
      );
      return;
    }

    if (selectedResponse !== 'Self-assessed' && !selectedCollectionMethod) {
      NotificationManager.error(
        t('activity.evaluation_plan.select_data_collection_method')
      );
      return;
    }

    if (!selectedObjective || selectedObjective.length === 0) {
      NotificationManager.error(
        t('activity.evaluation_plan.select_one_objective')
      );
      return;
    }

    if (!selectedGroups || selectedGroups.length === 0) {
      NotificationManager.error(
        t('activity.evaluation_plan.select_at_least_one_evaluation_group')
      );
      return;
    }

    const sampleSize = this.evaluationPlanForm.getSampleSize();
    const totalParticipants = this.evaluationPlanForm.getTotalParticipants();

    const method = find(methods, {
      // TODO:eval-form-updates
      response_id: selectedResponse,
      method_id: selectedMethod || '', // this field is empty string in db, not NULL
    });

    if (!method?.id) {
      NotificationManager.error(
        t('activity.evaluation_plan.invalid_evaluation_method')
      );
      return;
    }

    const isTakker = this.evaluationPlanForm.getIsTakker();

    const allValues = {
      isBetaQuestionText,
      name: get(values, 'name', ''),
      surveyTitle: get(values, 'surveyTitle', ''),
      collectionMethod: selectedCollectionMethod || 'LINK',
      objectives: selectedObjective,
      participantGroups: selectedGroups,
      methodId: method.id,
      sampleSize,
      totalParticipants,
      isTakker,
    };

    if (editMode) {
      allValues.isSeries = Boolean(Number(get(values, 'seriesCount', 0)));
      allValues.seriesCount = Number(get(values, 'seriesCount', 0));
    } else {
      allValues.isSeries = Boolean(
        this.evaluationPlanForm.getIsMultiStageEval()
      );
      allValues.seriesCount = Number(
        this.evaluationPlanForm.getMultiStageEvalCount()
      );
    }

    if (
      selectedCollectionMethod === 'LINK' ||
      selectedCollectionMethod === 'CSV'
    ) {
      allValues.customQuestions = this.evaluationPlanForm.getCustomQuestions();
      allValues.successMessage =
        this.evaluationPlanForm.getCustomSuccessMessage();
    }

    if (selectedResponse === 'Self-assessed') {
      allValues.evaluationQuestions = map(selectedObjective, (objective) => {
        const outcome = find(
          currentActivity.objective,
          (e) => e.id === objective
        );
        return {
          objectiveId: objective,
          outcomeId: outcome.outcomeId,
          methodId: method.id,
        };
      });
    } else {
      const evaluationQuestions =
        this.evaluationPlanForm.getEvaluationQuestion();
      allValues.evaluationQuestions =
        this.formatEvalQuestions(evaluationQuestions);
    }

    if (editMode) {
      updateEvaluationPlan(currentActivity.id, form.id, allValues, this);
    } else {
      postEvaluationPlan(currentActivity.id, allValues, this);
    }
  }

  getDfltForm() {
    const { t } = this.props;

    return {
      id: null,
      name: getNextEvaluationPlanName(
        get(this.props, 'currentActivity.evaluationPlans', [])
      ),
      surveyTitle: get(this.props, 'currentActivity.name', ''),
      isBetaQuestionText:
        this.props.currentActivity?.organisation?.gradedQuestions &&
        this.props.currentActivity?.organisation
          ?.activityUsesQuestionBetaByDefault,
      objectives: [],
      participantGroups: [],
      participants: [],
      customQuestions: [],
      collectionMethod: '',
      isTakker: false,
      facilitatorNote: '',

      // TODO:eval-form-updates
      // response: '',
      // method: '',
      response_id: '',
      method_id: '',

      evaluationQuestions: [],
      successMessage: t('survey.completion_message'),
      additionalAge: false,
      additionalQuestion: false,
      additionalPostcode: false,
      additionalEmail: false,
      additionalEmailLabel: '',
    };
  }

  success() {
    this.resetForm();
    this.setState({
      showCreatePlan: false,
    });
  }

  errorFound(error) {
    this.setState({
      showCreatePlan: true,
    });
  }

  forceFormReset() {
    this.setState(
      {
        loadEditing: true,
      },
      () => {
        this.form && this.form.reset();
        this.setState({ loadEditing: false });
      }
    );
  }

  resetForm() {
    this.setState(
      {
        form: this.getDfltForm(),
        editMode: false,
      },
      () => {
        this.forceFormReset();
      }
    );
  }

  async editPlan(form) {
    Promise.all([this.editEvalPlan(form), this.changeEvaluationPlanView()]);
  }

  async editEvalPlan(form) {
    const { clearMethodQuestions } = this.props;
    await clearMethodQuestions();
    const additionalEmail = find(
      form.customQuestions,
      (e) => e.type === 'EMAIL'
    );

    // create name without order format
    const setForm = {
      id: form.id,
      isBetaQuestionText: form.isBetaQuestionText,
      name: getEvaluationPlanBaseName(form),
      surveyTitle: form.surveyTitle || '',
      objectives: map(form.evaluationQuestions, (e) => e.objectiveId),
      participantGroups: map(form.participantGroups, (e) => e.targetGroupId),
      participants: form.participantGroups,
      customQuestions: form.customQuestions,
      collectionMethod: form.collectionMethod,
      facilitatorNote: form.method.facilitatorNote,
      isTakker: form.isTakker,

      // TODO:eval-form-updates
      method_id: form.method.method_id,
      response_id: form.method.response_id,

      evaluationQuestions: form.evaluationQuestions,
      successMessage: form.successMessage,
      additionalAge: find(form.customQuestions, (e) => e.type === 'AGE')
        ? true
        : false,
      additionalQuestion: find(form.customQuestions, (e) => e.type === 'FREE')
        ? true
        : false,
      additionalPostcode: find(
        form.customQuestions,
        (e) => e.type === 'POSTCODE'
      )
        ? true
        : false,
      additionalEmail: additionalEmail ? true : false,
      additionalEmailLabel: get(additionalEmail, 'label', ''),
      isSeries: Boolean(form.seriesParentId),
      seriesParticipantCountVaries: Boolean(form.seriesParticipantCountVaries),
      seriesCount: Number(form.seriesCount),
    };

    this.setState(
      {
        form: setForm,
        editMode: true,
        editNewForm: setForm,
      },
      () => {
        this.forceFormReset();
      }
    );
  }

  toggle() {
    this.setState((prevState) => ({
      modalShow: !prevState.modalShow,
    }));
  }

  getFormChanges(checkForm, editMode, editNewForm) {
    let formChanges = this.form && this.form.getValues();
    formChanges = omit(formChanges, ['EmailField', 'Question']);

    formChanges = {
      ...checkForm,
      ...formChanges,
    };

    // order by ids
    editNewForm.customQuestions = orderBy(
      editNewForm.customQuestions,
      ['id'],
      ['desc']
    );
    editNewForm.evaluationQuestions = orderBy(
      editNewForm.evaluationQuestions,
      ['objectiveId'],
      ['desc']
    );

    if (editMode) {
      formChanges.customQuestions = editNewForm.customQuestions;
      formChanges.additionalEmailLabel = editNewForm.additionalEmailLabel;
      formChanges.evaluationQuestions = editNewForm.evaluationQuestions;
      formChanges.facilitatorNote = editNewForm.facilitatorNote;
      formChanges.id = editNewForm.id;
      formChanges.participants = editNewForm.participants;
      formChanges.successMessage = editNewForm.successMessage;
      formChanges.collectionMethod = editNewForm.collectionMethod;
      if (formChanges.response !== 'Self-assessed') {
        if (
          formChanges.collectionMethod === 'LINK' ||
          formChanges.collectionMethod === 'CSV'
        ) {
          formChanges.customQuestions =
            this.evaluationPlanForm.getCustomQuestions();
          formChanges.successMessage =
            this.evaluationPlanForm.getCustomSuccessMessage();
        }
        if (formChanges.method_id !== '') {
          const evaluationQuestions =
            this.evaluationPlanForm.getEvaluationQuestion();
          formChanges.evaluationQuestions =
            this.formatEvalQuestions(evaluationQuestions);
        }
      }
      if (formChanges.response_id === 'Self-assessed') {
        delete formChanges.evaluationQuestions;
        delete editNewForm.evaluationQuestions;
      }
      //order by ids
      formChanges.customQuestions = orderBy(
        formChanges.customQuestions,
        ['id'],
        ['desc']
      );
      formChanges.evaluationQuestions = orderBy(
        formChanges.evaluationQuestions,
        ['objectiveId'],
        ['desc']
      );
    }

    return formChanges;
  }

  formatEvalQuestions(evaluationQuestions) {
    // pick important date from evaluation questions
    let data = map(evaluationQuestions, (e) =>
      pick(e, [
        'id',
        'objectiveId',
        'methodHeading',
        'heading',
        'question1',
        'question2',
        'outcomeId',
        'methodId',
      ])
    );
    // remove empty strings from question object
    data = map(data, (e) => {
      for (const key in e) {
        if (Object.hasOwnProperty.call(e, key)) {
          if (e[key] === '') {
            e[key] = null;
          }
        }
      }
      return e;
    });
    return data;
  }

  goBack() {
    const { checkForm, editMode, editNewForm } = this.state;
    const { currentActivity } = this.props;

    // get form changes
    const formChanges = this.getFormChanges(checkForm, editMode, editNewForm);
    // get initial form values
    let beforeData = editMode ? editNewForm : checkForm;

    // format evaluation questions
    beforeData.evaluationQuestions = this.formatEvalQuestions(
      beforeData.evaluationQuestions
    );

    //add the old edit value to the state editNewFrom
    let getParticipantGroups = find(currentActivity.evaluationPlans, {
      id: editNewForm.id,
    });
    let oldParticipantGroups = [];

    if (getParticipantGroups) {
      for (const item of getParticipantGroups.participantGroups) {
        oldParticipantGroups.push(item.targetGroupId);
      }
    }
    editNewForm.participantGroups = oldParticipantGroups;

    // check changes in form
    if (!isEqual(beforeData, formChanges)) {
      this.setState({
        modalShow: true,
      });
    } else {
      this.setState((prevState) => ({
        showCreatePlan: !prevState.showCreatePlan,
        editMode: false,
      }));
    }
  }

  navigationBack() {
    const { checkForm, editMode, editNewForm } = this.state;
    // get form changes
    const formChanges = this.getFormChanges(checkForm, editMode, editNewForm);
    // get initial form values
    let beforeData = editMode ? editNewForm : checkForm;
    // format evaluation questions
    beforeData.evaluationQuestions = this.formatEvalQuestions(
      beforeData.evaluationQuestions
    );

    // check changes in form
    if (!isEqual(beforeData, formChanges)) {
      return true;
    }
    return false;
  }

  leaveThePage() {
    this.setState((prevState) => ({
      modalShow: !prevState.modalShow,
      showCreatePlan: !prevState.showCreatePlan,
      editMode: false,
    }));
  }

  setShowCreatWarring(value) {
    this.setState({
      showCreatWarring: value,
    });
  }

  changeEvaluationPlanView(type) {
    const { getEvaluationPage, currentActivity, evaluationGroupSelected } =
      this.props;
    if (
      !isEmpty(currentActivity.objective) &&
      !isEmpty(evaluationGroupSelected)
    ) {
      getEvaluationPage(true);

      if (type === 'Add') {
        this.resetForm();
      }

      this.setState((prevState) => ({
        editMode: false,
        showCreatePlan: !prevState.showCreatePlan,
      }));
    } else {
      this.setShowCreatWarring(true);
    }
  }

  // set current activity evaluation
  setCurrentActivity = (currentEvaluation) => {
    this.setState({ currentEvaluation: currentEvaluation.data });
  };

  toggleSubtitleModal = (state, data = {}) => {
    this.setState({
      subtitleModal: state,
    });
    if (data) {
      this.setCurrentActivity({ data });
    }
  };

  // update or add series subtitle
  updateSeriesSubtitle = (event, values) => {
    const { updateSeriesSubtitle } = this.props;
    const { currentEvaluation } = this.state;
    const subtitle = get(values, 'series-subtitle', '');

    updateSeriesSubtitle(
      currentEvaluation.projectId,
      currentEvaluation.id,
      subtitle
    );
    this.setState({
      subtitleModal: false,
    });
  };

  toggleSubtitleDeleteModal = (state) => {
    this.setState({
      subtitleModal: false,
      subtitleDeleteModal: state,
      subtitleDeleteLoading: false,
    });
  };

  handleDeleteSubtitle = () => {
    const { t } = this.props;
    try {
      const { deleteSeriesSubtitle } = this.props;
      this.setState(
        {
          subtitleDeleteLoading: true,
        },
        async () => {
          const { currentEvaluation } = this.state;

          deleteSeriesSubtitle(
            currentEvaluation.projectId,
            currentEvaluation.id
          );

          this.setState({ subtitleDeleteLoading: false }, () => {
            NotificationManager.success(
              t('activity.evaluation.subtitle_deleted_successfully')
            );
            this.toggleSubtitleDeleteModal(false);
          });
        }
      );
    } catch (error) {
      console.error(error);
      NotificationManager.error(
        t('activity.evaluation.could_not_delete_subtitle'),
        t('common.something_went_wrong')
      );
    }
  };

  render() {
    const {
      showCreatePlan,
      form,
      loadEditing,
      editMode,
      modalShow,
      showCreatWarring,
      subtitleModal,
      currentEvaluation,
      subtitleDeleteModal,
      subtitleDeleteLoading,
    } = this.state;

    const { currentActivity, user, currentState, actPut, t } = this.props;

    return (
      <div>
        {/* <NavigationPrompt when={() => this.navigationBack() || false}> */}
        {({ onConfirm, onCancel }) => (
          <div className="msg-leave">
            <Modal
              onOpen={() => this.toggle()}
              size="tiny"
              open={true}
              closeIcon={
                <Icon onClick={onCancel} name="close" className="closeicon" />
              }
            >
              <Modal.Header className="warning-header-text">
                {t('activity.evaluation.leave_page_confirmation')}
              </Modal.Header>
              <Modal.Content className="warning-content-text">
                {t('activity.evaluation.unsaved_changes_message')}
              </Modal.Content>
              <div className="buttons-stay-leave">
                <Button onClick={onCancel} className="stay">
                  {t('actions.stay')}
                </Button>
                <Button
                  onClick={onConfirm}
                  content={t('actions.leave')}
                  className="leave"
                />
              </div>
            </Modal>
          </div>
        )}
        {/* </NavigationPrompt> */}

        <div className="msg-leave">
          <UnSavedModal
            modalShow={modalShow}
            toggle={() => this.toggle()}
            leaveThePage={() => this.leaveThePage()}
            t={t}
          />
        </div>

        {showCreatePlan ? (
          <Segment
            loading={actPut['evaluationPlans']}
            disabled={getPageDisable(currentActivity, user, currentState)}
            className="segment-eval-plans"
          >
            <AvForm
              ref={(c) => (this.form = c)}
              onValidSubmit={(event, values) =>
                this.handleValidSubmit(event, values)
              }
              autoComplete="off"
              onKeyPress={this.onKeyPress}
            >
              {loadEditing ? null : (
                <div>
                  <Segment.Group raised>
                    <Segment className="custom-segment">
                      <Fragment>
                        <div className="new-title">
                          <Icon
                            name="arrow left"
                            className="segment-icon-cursor"
                            onClick={() => this.goBack()}
                          />
                          {editMode
                            ? t('activity.evaluation.edit_evaluation_plan')
                            : t(
                                'activity.evaluation.create_new_evaluation_plan'
                              )}
                          <br></br>
                        </div>
                      </Fragment>
                    </Segment>
                    <EvaluationPlanForm
                      ref={(c) => (this.evaluationPlanForm = c)}
                      resetForm={() => this.resetForm()}
                      forceFormReset={() => this.forceFormReset()}
                      editMode={editMode}
                      changeEvaluationPlanView={(type) =>
                        this.changeEvaluationPlanView(type)
                      }
                      goBack={() => this.goBack()}
                      {...this.state}
                      {...this.props}
                    />
                  </Segment.Group>
                </div>
              )}
            </AvForm>
          </Segment>
        ) : (
          <div>
            <Modal
              open={subtitleModal}
              // onOpen={() => this.toggleSubtitleModal()}
              size="tiny"
              closeIcon={
                <Icon
                  onClick={() => this.toggleSubtitleModal(false)}
                  name="close"
                  className="closeicon"
                />
              }
            >
              <Modal.Header>
                {currentEvaluation.seriesSubtitle
                  ? t('specific_actions.edit_subtitle')
                  : t('activity.evaluation.add_subtitle_to_evaluation_series')}
              </Modal.Header>
              <Modal.Content>
                <AvForm
                  ref={(c) => (this.form = c)}
                  onValidSubmit={(event, values) =>
                    this.updateSeriesSubtitle(event, values)
                  }
                  autoComplete="off"
                  model={form}
                  onKeyPress={this.onKeyPress}
                >
                  <AvField
                    label={t('activity.evaluation.subtitle')}
                    className="subtitle-inputs"
                    name="series-subtitle"
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t('activity.evaluation.subtitle'),
                      },
                    }}
                    value={
                      currentEvaluation.seriesSubtitle
                        ? currentEvaluation.seriesSubtitle
                        : ''
                    }
                    onChange={(e) => {
                      this.setState({ seriesSubtitle: e.target.value });
                    }}
                    autoComplete="off"
                  />
                  <div className="d-flex mt-2">
                    <div className="">
                      {currentEvaluation.seriesSubtitle && (
                        <Button
                          className="modal-delete"
                          onClick={() => this.toggleSubtitleDeleteModal(true)}
                        >
                          {t('actions.delete')}
                        </Button>
                      )}
                    </div>
                    <div className="ml-auto">
                      <Button
                        className="modal-cancel mr-2"
                        onClick={() => this.toggleSubtitleModal(false)}
                      >
                        {t('actions.cancel')}
                      </Button>
                      <Button
                        // onClick={this.updateSeriesSubtitle}
                        className="modal-proceed"
                      >
                        {currentEvaluation.seriesSubtitle
                          ? t('actions.save')
                          : t('actions.add')}
                      </Button>
                    </div>
                  </div>
                </AvForm>
              </Modal.Content>
            </Modal>

            <EvaluationPlanList
              editPlan={(form) => this.editPlan(form)}
              resetForm={() => this.resetForm()}
              toggleSubtitleModal={this.toggleSubtitleModal}
              changeEvaluationPlanView={(type) =>
                this.changeEvaluationPlanView(type)
              }
              {...this.props}
            />
          </div>
        )}

        <SubtitleDeleteModal
          subtitleDeleteModal={subtitleDeleteModal}
          handleDeleteSubtitle={this.handleDeleteSubtitle}
          toggleSubtitleDeleteModal={this.toggleSubtitleDeleteModal}
          subtitleDeleteLoading={subtitleDeleteLoading}
        />
        <Modal
          centered
          open={showCreatWarring}
          onClose={() => this.setShowCreatWarring(false)}
          size="tiny"
        >
          <Modal.Header>{t('common.warning_shriek')}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {t('activity.evaluation.warning_message')}
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              className="warning"
              onClick={() => this.setShowCreatWarring(false)}
            >
              {t('common.ok')}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

class UnSavedModal extends PureComponent {
  render() {
    const { toggle, leaveThePage, modalShow, t } = this.props;
    return (
      <Modal
        size="tiny"
        open={modalShow}
        closeIcon={
          <Icon onClick={() => toggle()} name="close" className="closeicon" />
        }
      >
        <Modal.Header>
          {t('activity.evaluation.leave_page_confirmation')}
        </Modal.Header>
        <Modal.Content>
          {t('activity.evaluation.unsaved_changes_message')}
        </Modal.Content>
        <div className="buttons-stay-leave">
          <Button onClick={() => toggle()} className="stay">
            {t('actions.stay')}
          </Button>
          <Button
            onClick={() => leaveThePage()}
            content={t('actions.leave')}
            className="leave"
          />
        </div>
      </Modal>
    );
  }
}

class SubtitleDeleteModalBase extends PureComponent {
  render() {
    const {
      subtitleDeleteModal,
      handleDeleteSubtitle,
      toggleSubtitleDeleteModal,
      deleteSeriesSubtitleLoading,
      t,
    } = this.props;

    return (
      <Modal
        open={subtitleDeleteModal}
        closeIcon={
          <Icon
            onClick={() => toggleSubtitleDeleteModal(false)}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        // trigger={triggerComp}
      >
        <Modal.Header>
          {t('activity.evaluation.delete_confirmation')}
        </Modal.Header>
        <Modal.Content>
          <p>{t('activity.evaluation.delete_subtitle_confirmation')}</p>

          <div className="participant-delete-button-container">
            <Button
              onClick={() => toggleSubtitleDeleteModal(false)}
              className="modal-cancel"
            >
              {t('actions.cancel')}
            </Button>
            <Button
              className="modal-proceed"
              onClick={() => handleDeleteSubtitle()}
              content={t('actions.delete')}
              type="submit"
              loading={deleteSeriesSubtitleLoading}
              negative
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
    surveyQuestions: state.extra.surveyQuestions,
    methods: state.extra.methods,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMethodQuestions,
      clearMethodQuestions,
      getEvaluationGroups,
      postEvaluationPlan,
      deleteEvaluationPlan,
      updateEvaluationPlan,
      updateSeriesSubtitle,
      deleteSeriesSubtitle,
      getEvaluationPlans,
    },
    dispatch
  );
};

MainEvalPlan = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MainEvalPlan));

const SubtitleDeleteModal = withTranslation()(SubtitleDeleteModalBase);

export { MainEvalPlan, SubtitleDeleteModal };
